import "./App.css";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Gameplay from "./pages/Gameplay";
import About from "./pages/About";
import Media from "./pages/Media";
import Team from "./pages/Team";
import Contact from "./pages/Contact";
import Heroes from "./pages/Heroes";
import Hero from "./pages/Hero";
import Header from "./components/Header";
import Changelog from "./pages/Changelog";
import Items from "./pages/Items";
import Monsters from "./pages/Monsters";

function App() {
  return (
    <div className="App">
      <Router>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/gameplay" element={<Gameplay />} />
          <Route path="/about" element={<Home />} />
          <Route path="/media" element={<Media />} />
          <Route path="/team" element={<Team />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/heroes" element={<Heroes />} />
          <Route path="/items" element={<Items />} />
          <Route path="/monsters" element={<Monsters />} />
          <Route path="/changelog" element={<Changelog />} />
          <Route path="/hero/:name" element={<Hero />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
